import React from 'react';
import '../styles/Address.css';

function Address() {
  return (
    <div className="contact-container">
      <h2 className="section-title">Quick Contact With Us</h2>

      <div className="contact-right">
        <h3 className="map-header">
          Welcome To Akij Foundation <br /> Vocational School (AFVS)
        </h3>
        <iframe
          title="Akij Foundation Vocational School Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3650.7047541795655!2d90.23255547608148!3d23.79060757927723!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755f7bf05ef9fdb%3A0x2d6578ba28c957d!2sAkij%20foundation%20vocational%20school%2C%20MATI!5e0!3m2!1sen!2sbd!4v1729104000000!5m2!1sen!2sbd"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
}

export default Address;
